/* eslint-disable camelcase */

import React from 'react'

import TextField from '../BasicFields/TextField'
import SelectField from '../BasicFields/SelectField'
import { updateErrors } from '../SectionField'
import QuestionSettings from './QuestionSettings'

class Plan extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      id: props.question.id,
      context: props.question.context,
      position: props.question.position,
      title: props.question.title,
      mandatory: props.question.mandatory,
      variable_id: props.question.variable_id,
      errors: props.question.errors || {}
    }
  }

  shouldComponentUpdate(_nextProps, nextState) {
    this.state.errors = updateErrors(this.state.errors, this.props.getErrors)

    return (
      this.state.title !== nextState.title ||
      this.state.mandatory !== nextState.mandatory ||
      this.state.position !== nextState.position ||
      this.state.variable_id !== nextState.variable_id ||
      this.state.errors.isNew === true
    )
  }

  componentDidUpdate() {
    this.props.handleQuestionChange(this.state)
  }

  handleChange = event => this.setState({ [event.target.name]: event.target.value })

  handleMandatoryChange = event => this.setState({ mandatory: event.target.checked })

  planVariables() {
    const variables = this.props.data?.variables || []

    return variables.filter(variable => variable.variable_type === 'image')
  }

  render() {
    const variables = this.planVariables()

    return (
      <div className="nested-fields ml-2 ml-md-4">
        <div className="d-flex">
          <div className="mr-auto">
            <i className="fas fa-arrows-alt c-pointer" {...this.props.dragHandleProps} />
            {' Question plan '}
            <i
              className="fas fa-clone text-secondary c-pointer"
              onClick={this.props.handleQuestionDuplicate(this.state.id)}
            />
          </div>
          <i
            className="fas fa-trash danger-hover c-pointer"
            onClick={this.props.handleQuestionRemove(this.state.id)}
          />
        </div>
        <TextField
          name="title"
          value={this.state.title}
          placeholder="Titre de la question..."
          errors={this.state.errors.title}
          onChange={this.handleChange}
        />
        <SelectField
          name="variable_id"
          label="Plan (variable image)"
          data={variables}
          value={this.state.variable_id}
          errors={this.state.errors.variable}
          includeBlank
          onChange={this.handleChange}
        />
        {variables.length === 0 && (
          <div className="text-muted small mt-1">
            Aucune variable image disponible. Créez d&apos;abord une variable de ce type.
          </div>
        )}
        <QuestionSettings
          id={this.state.id}
          mandatory={this.state.mandatory}
          onMandatoryChange={this.handleMandatoryChange}
        />
      </div>
    )
  }
}

export default Plan
